import {Component, OnInit, ViewChild} from '@angular/core';
import {PageHeaderBarConfig, PageSubheaderBarConfig} from '../../../fw/pages/page-config-api';
import {BreadcrumService, BreadcrumStep } from '../../../fw/services/breadcrum.service';
import {AutoUnsubscribe} from '../../../fw/decoractors/AutoUnsubscribe';
import {FormBuilder, FormGroup} from "@angular/forms";
import {DynamicGridComponent} from "../../../fw/dynamic-grids/dynamic-grid.component";
import {ColumnDefinition} from "../../../fw/dynamic-grids/column-definition";
import {DtoArticleStockOverview} from "./models/DtoArticleStockOverview";
import {StockOverviewService} from "./stock-overview.service";
import {DtoCurrentStockBaseItems} from "./models/DtoCurrentStockBaseItems";
import {CashregGroupComponent} from "../../settings/settings-base/cashreggroup.component";
import {DialogService} from "@progress/kendo-angular-dialog";
import {ReportPreviewComponent} from "../../shared/report-preview.component";


@Component({
    selector: 'app-stock-overview',
    template: require('./stock-overview.component.html'),
    styles: [require('./stock-overview.component.css')]
})

@AutoUnsubscribe()
export class StockOverviewComponent implements OnInit {
    @ViewChild('grid', {static: false}) grid: DynamicGridComponent;
    filterHeaderConfig: PageHeaderBarConfig;
    pshbConfig: PageSubheaderBarConfig;
    activeItems: Array<{ text: string, value: boolean }> = [
        { text: "Ja", value: true },
        { text: "Nee", value: false }
    ];
    articleKinds: Array<{ text: string, value: number }> = [
        { text: "Alles", value: 0 },
        { text: "Verkoopproduct", value: 1 },
        { text: "Geen verkoopproduct", value: 2 }
    ];
    baseItems: DtoCurrentStockBaseItems;
    filterForm: FormGroup;
    data: DtoArticleStockOverview[];
    columnDefinition: ColumnDefinition[] = [
        {
            key: 'index',
            label: 'Nummer',
            type: 'number',
            width: '120px'
        },
        {
            key: 'description',
            label: 'Omschrijving',
            type: 'string',
            width: '*'
        },
        {
            key: 'firstSupplier',
            label: 'Leverancier',
            type: 'string',
            width: '*'
        },
        {
            key: 'stockCurrent',
            label: 'Voorraad',
            type: 'number',
            width: '110px'
        },
        {
            key: 'stockMin',
            label: 'Min. voorraad',
            type: 'number',
            width: '120px'
        },
        {
            key: 'purchasePriceEx',
            label: 'Inkoop',
            type: 'number',
            width: '110px',
            format: '{0:c}'
        },
        {
            key: 'retailPriceEx',
            label: 'Verkoop',
            type: 'number',
            width: '110px',
            format: '{0:c}'
        },
        {
            key: 'totPurchasePrice',
            label: 'Tot. inkoop',
            type: 'number',
            width: '110px',
            format: '{0:c}'
        },
        {
            key: 'totRetailPrice',
            label: 'Tot. verkoop',
            type: 'number',
            width: '110px',
            format: '{0:c}'
        },
        {
            key: 'totMarge',
            label: 'Marge',
            type: 'number',
            width: '110px',
            format: '{0:c}'
        }
    ];

    constructor(private breadcrumService: BreadcrumService,
                private fb: FormBuilder,
                private ds: StockOverviewService,
                private dialogService: DialogService) { }

    ngOnInit() {
        let steps: Array<BreadcrumStep> = [
            { text: 'hoofdmenu', isLastStep: false },
            { text: 'voorraad', isLastStep: false },
            { text: 'voorraad overzicht', isLastStep: true }];
        this.breadcrumService.setCurrentLocation(steps, true, 'home');
        this.filterHeaderConfig = {
            title: 'INSTELLINGEN',
            buttonDefinition: [
                {
                    description: 'BEKIJKEN',
                    isSmall: false,
                    clickEventType: 'search'
                }
            ]
        };

        this.pshbConfig = {
            title: 'HUIDIGE VOORRAAD',
            buttonDefinition: [
                {
                    description: 'AFDRUKKEN',
                    isSmall: false,
                    clickEventType: 'print'
                }
            ]
        };

        this.filterForm = this.fb.group({
            showNoStock: true,
            supplierId: 0,
            kind: 0,
            userId: 0
        });

        this.ds.getCurrentStockBaseItems().subscribe((res: DtoCurrentStockBaseItems) => {
            this.baseItems = res;
            this.loadData();
        });
    }

    loadData() {
        this.grid.clearData();
        this.data = [];
        this.ds.getCurrentStock({
            userId: this.filterForm.get('userId').value,
            supplierId: this.filterForm.get('supplierId').value,
            kind: this.filterForm.get('kind').value,
            showNoStock: this.filterForm.get('showNoStock').value
        }).subscribe((res: DtoArticleStockOverview[]) => {
            this.data = res;
            if (this.data.length > 0) {
                this.grid.showData(this.data);
            }
        });
    }

    printOverview() {
        const dialogRef = this.dialogService.open({
            content: ReportPreviewComponent
        });

        const dialogContent: ReportPreviewComponent = dialogRef.content.instance;
        dialogContent.dialog = dialogRef;
        dialogContent.reportName = 'StockOverview';
        dialogContent.reportParams = [
            {
                name: 'supplierId',
                value: this.filterForm.get('supplierId').value.toString()
            },
            {
                name: 'printAll',
                value: this.filterForm.get('showNoStock').value ? 'true' : 'false'
            },
            {
                name: 'salesArticle',
                value: this.filterForm.get('kind').value.toString()
            }
        ];
    }

    phbBtnClicked(event) {
        if (event == 'search') {
            this.loadData();
        }
    }

    pshbBtnClicked(event) {
        if (event == 'print') {
            this.printOverview();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/stock/stock-overview/stock-overview.component.ts